import i18n from '@/plugins/i18n';
import store from '@/store/store';
import { computed } from 'vue';

// eslint-disable-next-line import/prefer-default-export
export const useHandlebars = computed(() => store.state.messageCenter.handlebars);

export const useHandlebarPlaceholders = computed(() => { // (): {id: number, name: string}[] {
  const handlebars = useHandlebars.value.map((o) => ({ id: o.id, name: i18n.tc(`code.handlebar.${o.name}`) }));
  return handlebars;
});
